//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import * as api from '@/api/protocols';
import { policyPrintForPa } from '@/api/apis';
import List_obj from './list_obj.js';
import { proposalQueryList } from '@/api/policymanagement';
export default {
  // name: 'ProtocolView',
  name: 'downloadPolicy',
  inject: ['reload'],
  data: function data() {
    return {
      loading: true,
      dialogStatus: '',
      isDisable: false,
      protocolStatusList: List_obj.protocolStatusList,
      dialogFormVisible: false,
      trueOrFalse: List_obj.trueOrFalse,
      // 是否判断
      disableFlag: true,
      fileTypes: List_obj.fileType,
      printLanguages: List_obj.printLanguage,
      dzTypes: List_obj.dzType,
      yzTypes: List_obj.yzType,
      paperTypes: List_obj.paperType,
      protoForm: {
        partnerCode: '',
        policyNo: '',
        protocolNo: '',
        applyPolicyNo: '',
        endorseNo: '',
        documentType: '4',
        languagePrint: '0',
        isElectronic: '1',
        isPrintInsurant: '0',
        isPrintAddrAndPost: '0',
        sealTypeepas: '0',
        paperTypeepas: '1',
        isPrintClauseebcs: '0',
        isCorporationSealebcs: '0',
        isNeedEmployeeList: '0',
        fileType: '01'
      },
      userId: '',
      total: 0,
      pageShow: false
    };
  },
  watch: {
    '$route': 'getSearchData'
  },
  mounted: function mounted() {
    this.searchProto(1);
  },
  created: function created() {
    var _this = this;

    var companyCode = this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode || '';
    var companyName = this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyName || '';
    var proposalNo = this.$route.params.proposalNo;
    console.log(proposalNo);
    proposalQueryList({
      'proposalNo': proposalNo,
      'pageNo': '1',
      'pageSize': '10'
    }).then(function (res) {
      console.log(res);
      _this.protoForm.applyPolicyNo = res.content[0].businessNo;
      _this.protoForm.policyNo = res.content[0].policyNo;
      _this.protoForm.partnerCode = 'P_BJS_GP';
    });
    this.protoForm.insurancecompanyCode = companyCode;
    this.protoForm.insuranceCompanyName = companyName;
    console.log('保险公司Code', this.protoForm.insurancecompanyCode);
    console.log('保险公司Name', this.protoForm.insuranceCompanyName);
    console.log('保险公司code1111', companyCode);
    this.userId = this.$store.state.user.userinfo.userId;
  },
  methods: {
    policy_Print: function policy_Print() {
      var _this2 = this;

      this.isDisable = true;
      setTimeout(function () {
        _this2.isDisable = false; //点击一次时隔五秒后才能再次点击
      }, 5000);
      var params = {
        partnerCode: this.protoForm.partnerCode || '',
        policyNo: this.protoForm.policyNo || '',
        applyPolicyNo: this.protoForm.applyPolicyNo || '',
        endorseNo: this.protoForm.endorseNo || '',
        documentType: this.protoForm.documentType || '',
        languagePrint: this.protoForm.languagePrint || '',
        isElectronic: this.protoForm.isElectronic || '',
        isPrintInsurant: this.protoForm.isPrintInsurant || '',
        isPrintAddrAndPost: this.protoForm.isPrintAddrAndPost || '',
        sealTypeepas: this.protoForm.sealTypeepas || '',
        paperTypeepas: this.protoForm.paperTypeepas || '',
        isPrintClauseebcs: this.protoForm.isPrintClauseebcs || '',
        isCorporationSealebcs: this.protoForm.isCorporationSealebcs || '',
        isNeedEmployeeList: this.protoForm.isNeedEmployeeList || '',
        fileType: this.protoForm.fileType || ''
      };
      console.log(params);
      policyPrintForPa(params).then(function (res) {
        console.log(1234);
      });
    },

    /**
     * 重置
     */
    restProto: function restProto() {
      this.protoForm = {
        protocol2Code: '',
        protocolNo: '',
        handler1Code: '',
        currency: '',
        agreementStartDate: '',
        agreementEndDate: '',
        appliName: '',
        insuredName: '',
        riskCode: '',
        protocolStatus: '00',
        auditStatus: '1',
        pageNo: '1',
        pageSize: '10'
      };
      var companyCode = this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode || '';
      var companyName = this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyName || '';
      this.protoForm.insurancecompanyCode = companyCode;
      this.protoForm.insuranceCompanyName = companyName;
    }
  }
};